import React, { useState }from 'react';
import Cookies from 'universal-cookie';
import axios from 'axios';

import signinImage from '../assets/signup3.png';

const cookies = new Cookies();

const initialState = {
    fullName: '',
    username: '',
    password: '',
    confirmPassword: '',
    phoneNumber: '',
    avatarURL: ''
}


const Auth = () => {
const [form, setForm] = useState(initialState);    
//state is set to signup page. changing state to false will display login page instead
const [isSignup, setIsSignup] = useState(true); 


const handleChange = (event) => {
    
    setForm({...form, [event.target.name]: event.target.value});
    //console.log(form);
}

const handleSubmit = async (event) => {
    event.preventDefault(); // prevents page from reloading

    const {username, password, phoneNumber, avatarURL} = form;
    //const URL = 'http://localhost:5000/auth'; // will changes this URL when I host the back-end
    const URL = 'https://zip-chatter.herokuapp.com/auth';

    const {data: { token, userId, hashedPassword, fullName} } = await axios.post(`${URL}/${isSignup ? 'signup' : 'login'}`, {
     username, password, fullName: form.fullName, phoneNumber, avatarURL   
    }); // now full Name from sign up form wll persist
    
    cookies.set('token', token);
    cookies.set('username', username);
    cookies.set('fullName', fullName);
    cookies.set('userId', userId);

    if(isSignup){
        cookies.set('phoneNumber', phoneNumber);
        cookies.set('avatarURL', avatarURL);
        cookies.set('hashedPassword', hashedPassword);
         
    }

window.location.reload();
}


//will switch to  previous state
const switchMode = () => {
    setIsSignup((prevIsSignup) => !prevIsSignup)  
}

    return (
        <div className='auth__form-container'>
         <div className='auth__form-container_fields'>
            <div className='auth__form-container_fields-content'>
                <p>{isSignup ? 'Sign Up' : 'Sign In'}</p>
                <form onSubmit={handleSubmit}>
                    {isSignup && (
                     <div className='auth__form-container_fields-content_input'>
                        <label htmlFor='fullName'>Full Name</label>
                        <input
                            name='fullName'
                             type='text'
                             placeholder='Full Name'
                             onChange={handleChange}
                             required
                        />
                     </div>   
                    )}
                    <div className='auth__form-container_fields-content_input'>
                        <label htmlFor='username'>Username</label>
                        <input
                            name='username'
                             type='text'
                             placeholder='Username'
                             onChange={handleChange}
                             required
                        />
                     </div>  
                     {isSignup && (
                     <div className='auth__form-container_fields-content_input'>
                        <label htmlFor='phoneNumber'>Phone Number</label>
                        <input
                            name='phoneNumber'
                             type='text'
                             placeholder='Phone Number'
                             onChange={handleChange}
                             required
                        />
                     </div>   
                    )} 
                    {isSignup && (
                     <div className='auth__form-container_fields-content_input'>
                        <label htmlFor='avatarURL'>Avatar URL</label>
                        <input
                            name='avatarURL'
                             type='text'
                             placeholder='Avatar URL'
                             onChange={handleChange}
                             required
                        />
                     </div>   
                    )} 
                    <div className='auth__form-container_fields-content_input'>
                        <label htmlFor='password'>Password</label>
                        <input
                            name='password'
                             type='password'
                             placeholder='Password'
                             onChange={handleChange}
                             required
                        />
                     </div>  

                     {isSignup && (
                     <div className='auth__form-container_fields-content_input'>
                        <label htmlFor='confirmPassword'>Confirm Password</label>
                        <input
                            name='confirmPassword'
                             type='password'
                             placeholder='Confirm Password'
                             onChange={handleChange}
                             required
                        />
                     </div> 
                        )} 
                        <div className='auth__form-container_fields-content_button'>
                            <button> {isSignup ? 'Sign Up' : 'Sign In'}</button>
                        </div>
                </form>
                <div className='auth__form-container_fields-account'>
                        <p>
                           {isSignup 
                           ?  'Already have an account?'
                           : "Don't have an account?"
                           } 
                           <span onClick={switchMode}>
                            {isSignup ? 'Sign In' : 'Sign Up'}
                           </span>
                        </p>
                </div>
            </div>
         </div>
         <div className='auth__form-container_image'>
                <img  src={signinImage} alt='sign in'/>
         </div>
        </div>
    )
}

export default Auth
